<template>
  <div>
    <div class="banner">
      <div class="EC_width">
        <div class="display_between">
          <div class="leftBan">
            <img :src="apiData.topsHead.headImg">
            <p class="name">{{apiData.topsHead.name}}</p>
            <p class="signName">{{apiData.topsHead.sign}}</p>
            <div class="showInfor">
              <img src="/image/quanke/inforImg.png"
                   class="marginRight5"><span>{{apiData.topsHead.msgNum}}</span>
              <img src="/image/quanke/xianshiImg.png"
                   class="marginLeft20 marginRight5"><span>{{apiData.topsHead.seeNum}}</span>
            </div>
            <div class="btnWrap">
              <a href="javascript:void(0);"
                 class="headbtn">+订阅</a>
              <a href="javascript:void(0);"
                 class="headbtn headbtnRed"
                 @click="showImg=true">个人名片</a>
              <a href="javascript:void(0);"
                 class="headbtn headbtnBlue"
                 @click="showMsg=true">发送站内信</a>
            </div>
          </div>
          <div class="rightBan">
            <img src="/image/quanke/signbg.png"
                 class="signBg">
            <a href="javascript:void(0);">
              <img src="/image/quanke/fanhui.png"
                   style="vertical-align: -6px;">
              <span class="marginLeft5">返回个人中心</span>
            </a>
            <p class="rightTitle">{{apiData.topsHead.introTitle}}</p>
            <p>{{apiData.topsHead.skill}}</p>
            <div class="border_bottom_18">
            </div>
            <div class="titleContent">
              {{apiData.topsHead.intro}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <customModal :showmodal.sync="showMsg"
                 width="800px">
      <div class="fontBold">留言</div>
      <div class="textArea">
        <textarea style="width: 100%;height: 100%"
                  maxlength="200"
                  v-model="myMsg"
                  placeholder="为了更好、更快捷的沟通，请您尽量详实、准确的描述您的留言。">

            </textarea>
      </div>
      <div class="display_between">
        <div></div>
        <div>{{myMsg.length}}/200</div>
      </div>
      <div>
        <span class="marginRight10">上传图片</span>
        <img :src="imgUplod"
             alt="">
        <div style="display: inline-block">

          <template v-if="imgUpload.length>0">
            <img :src="item"
                 alt=""
                 @click="delImg(index)"
                 style="width: 52px;height: 52px;vertical-align: middle;cursor: pointer"
                 class="marginRight10"
                 v-for="(item,index) in imgUpload"
                 :key="index">
          </template>
          <img v-show="imgUpload.length<2"
               src="/image/jigou/addimg.png"
               alt=""
               style="vertical-align: middle;cursor: pointer"
               @click="selectImg">
          <input type="file"
                 ref="imgSet"
                 @change="imgget"
                 accept="image/gif, image/jpeg, image/jpg, image/png, image/svg"
                 v-show="false">
        </div>
        <span class="marginLeft10">最多上传2张照片</span>
      </div>
      <div class="text_center">
        <a href="javascript:;"
           class="gl_pad_btn marginRight20"
           style="width: 110px">提交</a>
        <a href="javascript:;"
           class="gl_pad_btn"
           style="width: 110px"
           @click="showMsg=false">取消</a>
      </div>

    </customModal>
    <custom-modal :showmodal.sync="showImg"
                  :content="false">
      <template v-slot:content>
        <div style="position: relative">
          <img src="/image/qkxy/closemodal.png"
               alt=""
               class="close"
               @click="showImg=false">
          <img src="/image/jigou/mingpian.png"
               alt="">
        </div>
      </template>

    </custom-modal>
    <div class="EC_width">
      <div class="border_bottom_18  marginTop40 marginBottom20">
        <div class="gl_title_vertical_line gl_title_v_line_active fontBold">
          TA的动态
        </div>
      </div>
      <div class="display_between">
        <div>
          <img :src="apiData.dynamic.img">
        </div>
        <div class="flex1 marginLeft40 listCourse">
          <div class="listitem display_between border_bottom_18"
               v-for="(item,index) in apiData.dynamic.data"
               :key="index">
            <div>
              {{item.title}}
            </div>
            <div>
              更多>>
            </div>
          </div>
        </div>
      </div>
      <div class="border_bottom_18  marginTop40 marginBottom20">
        <div class="gl_title_vertical_line gl_title_v_line_active fontBold">
          TA的音频
        </div>
      </div>
      <div class="positionBtn marginBottom50">
        <swiper :options="swiperaudio"
                ref="swiperTop">
          <swiper-slide v-for="(item,index) in apiData.audio"
                        :key="index">
            <a href="javascript:;"
               class="mediaImg">
              <div class="display_between">
                <span class="audioWrap">
                  <img src="/image/quanke/yinpin.png">
                </span>
                <span class="titleAudio">{{item.title}}</span>
              </div>
              <div class="playNum"><img src="/image/quanke/playsmall.png"
                     style="vertical-align: 2px;margin-right: 7px;">{{item.num}}</div>
            </a>
          </swiper-slide>
        </swiper>
        <div class="prevbutton2">&lt;</div>
        <div class="nextbutton2">&gt;</div>
      </div>
    </div>
    <div class="grayBg">
      <div class="EC_width">
        <div class="border_bottom_18  marginTop40 marginBottom20">
          <div class="gl_title_vertical_line gl_title_v_line_active fontBold">
            TA的课程
          </div>
        </div>
        <swiper :options="swiperColumn"
                style="padding-bottom: 40px">
          <swiper-slide v-for="(item,index) in apiData.course"
                        :key="index">
            <div class="pub_square">
              <div class="pubs_img">
                <img :src="item.img">
              </div>
              <div class="pubs_body">
                <div class="pubs_title">
                  {{item.title}}
                </div>
                <div class="pubs_label display_between">
                  <div>
                    <span v-for="(itemx,indexx) in item.sign"
                          :key="indexx">{{itemx}}</span>

                  </div>
                  <div class="pubs_cancel">
                    取消收藏
                  </div>
                </div>
                <div class="display_between">
                  <div class="pubs_tip">
                    <span class="redColor">{{item.price}}</span>
                  </div>
                  <div class="pubs_rentou">
                    <img src="/image/geren/ren.png">{{item.num}}人
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination"
               slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <div class="EC_width">
      <div class="border_bottom_18  marginTop40 marginBottom20 display_between">
        <div class="gl_title_vertical_line gl_title_v_line_active fontBold">
          TA的学术
        </div>
        <div>
          <img src="/image/index/moreimg.png"
               class="imgvertical-2 marginRight10">更多
        </div>
      </div>
      <div class="display_flex">
        <div class="leftCanvas">
          <img src="/image/quanke/oracl.png">
          <span>论文著作</span>
          <span class="normalColor fontsize22">217</span>
          <span class="normalColor">篇/本</span>
        </div>
        <div class="rightList">
          <div class="marginBottom30"
               v-for="(item,index) in apiData.study"
               :key="index">
            <div class="gl_title_vertical_line gl_title_v_line_active fontBold fontsize22 marginBottom10">
              {{item.title}}
            </div>
            <p>{{item.intro}}</p>
            <p>{{item.abstract}}</p>
          </div>
        </div>
      </div>
      <div class="border_bottom_18  marginTop40 marginBottom20">
        <div class="gl_title_vertical_line gl_title_v_line_active fontBold">
          TA的Link
        </div>
      </div>
      <div class="positionBtn EC_width">
        <swiper :options="linkSwiper">
          <swiper-slide v-for="(item,index) in apiData.mylink"
                        :key="index">
            <a href="javascript:;"
               class="linkmedia">
              <img :src="item.img">
              <p>{{item.title}}</p>
            </a>
          </swiper-slide>
        </swiper>
        <div class="prevbutton2">&lt;</div>
        <div class="nextbutton2">&gt;</div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "expertDetails",
  data () {
    return {
      apiData: "",
      showMsg: false,
      showImg: false,
      imgUpload: [],
      myMsg: "",
      swiperaudio: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 10,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton2',
          prevEl: '.prevbutton2',
          disabledClass: 'my-button-disabled',
        },
      },
      swiperColumn: {
        slidesPerView: 4,
        slidesPerColumn: 2,
        slidesPerColumnFill: 'row',
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'bulletWrite2',
          bulletActiveClass: 'bulletWriteActive2',
        },
      },
      linkSwiper: {
        slidesPerView: 6,
        slidesPerGroup: 1,
        spaceBetween: 10,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton2',
          prevEl: '.prevbutton2',
          disabledClass: 'my-button-disabled',
        },
      }
    }
  },
  methods: {
    getData () {
      var that = this;
      fetch("/data.json").then((res) => {
        return res.json()
      }).then(data => {
        that.apiData = data.expertDetails;
      })
    },
    selectImg () {
      this.$refs.imgSet.click()
    },
    imgget (e) {
      let file = e.target.files[0];
      var reader = new FileReader();

      reader.onload = (data) => {
        let res = data.target || data.srcElement;
        this.imgUpload.push(res.result)
      }
      if (!file) return;
      reader.readAsDataURL(file)
    },
    delImg (index) {
      this.imgUpload.splice(index)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getData()
    })

  }
}
</script>

<style scoped>
.wrap {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 60px;
}
.qk_head {
    height: 77px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.pub_left_logo {
    width: 420px;
}

.pub_center_menu {
    flex: 1;
    height: 100%;
}

.pub_menu {
    list-style: none;
    padding: 0;
    margin: 0;
    overflow: hidden;
    height: 100%;
}

.pub_menu li {
    float: left;
    height: 100%;
    line-height: 77px;
}

.pub_menu li a {
    padding: 0 20px;
}

.pub_menu_active a {
    color: #0b8686;
}

.pub_right_opra {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.inputRelative {
    position: relative;
    display: inline-block;
}

.pub_head_bar_search {
    width: 200px;
    height: 24px;
    box-sizing: border-box;
    border-radius: 24px;
    outline: none;
    border: 1px solid #ddd;
    padding-left: 12px;
}

.inputRelative img {
    position: absolute;
    right: 11px;
    top: 3px;
    cursor: pointer;
}

.pub_mes_img {
    margin: 0 20px;
}

.pub_bar_headimg {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 24px;
    overflow: hidden;
    line-height: 24px;
    text-align: center;
    border: 1px solid #ddd;
}

/* 面包屑导航 */
.breadcrumb_wrap {
    min-width: 1300px;
    list-style: none;
    height: 40px;
    background: #f2f2f2;
    display: flex;
}
.set_breadcrumb {
    list-style: none;
    line-height: 40px;
    height: 100%;
    padding: 0;
}
.set_breadcrumb li {
    display: inline-block;
    font-size: 12px;
    color: #0b8485;
}
.set_breadcrumb li ~ li:before {
    content: '>';
    margin-left: 4px;
    margin-right: 4px;
    color: #333;
}
.set_breadcrumb li a {
    display: inline-block;
    font-size: 12px;
    color: #333;
}
.breadcrumb_search input {
    width: 200px;
    height: 30px;
    box-sizing: border-box;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    outline: none;
    border: 1px solid #f2f2f2;
    padding-left: 10px;
}
.ArrIcon {
    display: inline-block;
    width: 50px;
    height: 30px;
    background: #0b8686;
    border-radius: 0 30px 30px 0;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
}
.blocknext,
.blockpre {
    display: inline-block;
    width: 16px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    box-sizing: border-box;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 10px;
    z-index: 10;
    cursor: pointer;
    outline: none;
}
.blocknext {
    right: 0;
}
.blockpre {
    left: 0;
}
/* 轮播按钮 */
.nextbutton,
.prevbutton,
.nextbutton2,
.prevbutton2 {
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 40%;
    z-index: 10;
    cursor: pointer;
    outline: none;
}
.nextbutton2,
.prevbutton2 {
    top: 40%;
}
.nextbutton,
.nextbutton2 {
    right: -30px;
    left: auto;
}

.prevbutton,
.prevbutton2 {
    right: auto;
    left: -30px;
}

.my-button-disabled {
    background: #ddd;
    color: #999;
}

.banner {
    padding-top: 80px;
    height: 526px;
    background: url(/image/quanke/bannernew.png) center no-repeat;
    box-sizing: border-box;
}

.leftBan {
    left: 195px;
    margin-top: -130px;
}

.name {
    font-size: 26px;
    color: #ffffff;
    font-weight: bold;
    text-align: center;
}

.signName {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    margin-top: 10px;
}

.showInfor {
    width: 195px;
    height: 36px;
    border-radius: 18px;
    box-sizing: border-box;
    padding: 10px 0;
    text-align: center;
    color: #fff;
}

.rightBan {
    background: url(/image/quanke/bgTop.png) center no-repeat;
    width: 1005px;
    height: 412px;
    position: relative;
    padding-left: 67px;
    padding-right: 88px;
    box-sizing: border-box;
    padding-top: 34px;
}

.signBg {
    position: absolute;
    top: -47px;
    right: 76px;
}

.signBtnRed {
    display: inline-block;
    width: 130px;
    height: 30px;
    background: #df0018;
    border-radius: 15px;
    text-align: center;
    line-height: 30px;
    color: #fff;
    font-weight: bold;
    color: #ffffff;
}
.signBtnblue {
    display: inline-block;
    width: 130px;
    height: 30px;
    background: #dff3f4;
    border: 1px solid #0b8586;
    border-radius: 15px;
    text-align: center;
    line-height: 30px;
    color: #fff;
    font-weight: bold;
    color: #0b8586;
}
.rightTitle {
    color: #0b8586;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    margin-top: 25px;
    margin-bottom: 19px;
}
.titleContent {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
    margin-top: 20px;
}
.grayBg {
    background: #f6f7fb;
    padding: 60px 0;
}
.leftCanvas {
    flex: 1;
}
.rightList {
    width: 516px;
    height: 340px;
    overflow: auto;
    margin-left: 60px;
}
.headbtn {
    display: block;
    width: 160px;
    height: 30px;
    background: #ffffff;
    border-radius: 15px;
    text-align: center;
    line-height: 30px;
    margin: 0 auto;
    margin-bottom: 10px;
}
.headbtnRed {
    background: #df0019;
    color: #fff;
}
.headbtnBlue {
    background: #003157;
    color: #fff;
}
.listCourse {
    height: 158px;
    overflow-y: auto;
}
.rightList::-webkit-scrollbar {
    width: 5px;
    background: #eeeeee;
}

/* 滚动槽 */
.rightList::-webkit-scrollbar-track {
    border-radius: 10px;
}

/* 滚动条滑块 */
.rightList::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #0b8586;
}
.listCourse::-webkit-scrollbar {
    width: 5px;
    background: #eeeeee;
}

/* 滚动槽 */
.listCourse::-webkit-scrollbar-track {
    border-radius: 10px;
}

/* 滚动条滑块 */
.listCourse::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #0b8586;
}

.listCourse::-webkit-scrollbar-thumb:window-inactive {
    background: #0b8586;
}
.listitem {
    margin-top: 16px;
}
.listitem:hover {
    color: #0b8485;
    cursor: pointer;
}
/* 轮播宽度 */
.positionBtn {
    margin-top: 20px;
    position: relative;
    width: 1300px;
}
.mediaImg {
    display: inline-block;
    width: 291px;
    height: 125px;
    background: #f6f7fb;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 15px;
}
.audioWrap {
    width: 76px;
    height: 49px;
    display: inline-block;
    background: url(/image/quanke/bgyin.png) center no-repeat;
    text-align: center;
    line-height: 49px;
    box-sizing: border-box;
    padding-top: 10px;
    border-radius: 10px;
}
.titleAudio {
    margin-left: 20px;
    border-bottom: 1px solid #ddd;
    padding-bottom: 20px;
}
.playNum {
    text-align: center;
    padding-top: 16px;
}
.swiper-slide {
    margin-bottom: 10px;
}

.colunmSwiper {
    padding-bottom: 40px;
}
.linkmedia {
    text-align: center;
    display: block;
}
.linkmedia p {
    margin-top: 10px;
}
.textArea {
    height: 179px;
    box-sizing: border-box;
    padding: 20px;
    margin-top: 10px;
    border: 1px solid #ddd;
}
.textArea textarea {
    border: none;
    outline: none;
}
.gl_pad_btn {
    text-align: center;
}
.gl_pad_btn:hover {
    background: #0b8686;
    color: #fff;
}
.close {
    position: absolute;
    right: 10px;
    top: 10px;
}
</style>
